import {isLocal} from "./devLiveCheck.js";

/* for some reason React doesnt deal with bg image paths in CSS files very well
this is a hack so the main bg image of <body> displays in dev and live
*/ 

/* wait a sec. why the fuck didnt we just use an absolute path?*/ 
(function(){
    if(!isLocal()){
        document.body.style.backgroundImage = "url('http://www.webnamehere.com/jarvis/images/bgPatternTriangles.png')";
    }else{
        document.body.style.backgroundImage = "url('/images/bgPatternTriangles.png')";            
    }
})()



// WEBPACK FOOTER //
// ./src/components/includes/behindTheScenes/body_bgImage_hack.js